@if (filteredItems(); as filteredItems) { @if (filteredItems.length) { @for (infoTableItem of filteredItems; track
infoTableItem.title; let first = $first; ) {
<div class="ui-info-table" [class.push-top-xs]="!first" [class.push-top-sm]="first" libFlexRow [libFlexRowGap]="'8px'">
	<div libText3 libFlexColumn [libFlexSize]="'fill'">{{ infoTableItem.title }}:</div>
	<div libText2 libFlexColumn [libFlexSize]="undefined">
		<span
			[class.ui-value-clickable]="infoTableItem.valueClick ? true : false"
			(click)="infoTableItem.valueClick?.()"
			>{{ infoTableItem.value }}</span
		>
	</div>
</div>
}} }
